(function () {
    'use strict';

    // @ngInject
    function CapterraServiceCtor($window) {
        this.$window = $window;
    }

    Services.CapterraService = Class(function () {
        return {
            constructor: CapterraServiceCtor,

            trackConversion: function trackConversion(){
                var capterra_vkey = '6f82d56cb8c0095ccf7b864d804d285c',
                    capterra_vid = '2113583',
                    capterra_prefix = (('https:' === document.location.protocol) ? 'https://ct.capterra.com' : 'http://ct.capterra.com');

                var ct = document.createElement('script');
                ct.type = 'text/javascript';
                ct.async = true;
                ct.src = capterra_prefix + '/capterra_tracker.js?vid=' + capterra_vid + '&vkey=' + capterra_vkey;

                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(ct, s);
            }
        };
    });

}());
